import { OrderStatus, OrderType } from "@cronika/proto/common/billing_pb";
import { CurrencyCode, CurrencyType, NetworkCode, PaymentProvider } from "@cronika/proto/common/payment_pb";

// ---------------------------------------------------------------------------
// Label maps  (numeric proto enum value -> human-readable string)
// ---------------------------------------------------------------------------

export const ORDER_STATUS_LABEL: Record<number, string> = {
  [OrderStatus.CREATED]: "Created",
  [OrderStatus.PROCESSING]: "Processing",
  [OrderStatus.COMPLETED]: "Completed",
  [OrderStatus.FAILED]: "Failed",
  [OrderStatus.CANCELED]: "Canceled",
  [OrderStatus.EXPIRED]: "Expired",
};

export const ORDER_TYPE_LABEL: Record<number, string> = {
  [OrderType.DEPOSIT]: "Deposit",
  [OrderType.WITHDRAWAL]: "Withdrawal",
};

export const CURRENCY_TYPE_LABEL: Record<number, string> = {
  [CurrencyType.FIAT]: "Fiat",
  [CurrencyType.CRYPTO]: "Crypto",
};

export const CURRENCY_CODE_LABEL: Record<number, string> = {
  [CurrencyCode.USD]: "USD",
  [CurrencyCode.RUB]: "RUB",
  [CurrencyCode.KZT]: "KZT",
  [CurrencyCode.EUR]: "EUR",
  [CurrencyCode.CNY]: "CNY",
  [CurrencyCode.JPY]: "JPY",
  [CurrencyCode.GBP]: "GBP",
  [CurrencyCode.CHF]: "CHF",
  [CurrencyCode.SGD]: "SGD",
  [CurrencyCode.HKD]: "HKD",
  [CurrencyCode.NZD]: "NZD",
  [CurrencyCode.USDT]: "USDT",
  [CurrencyCode.USDC]: "USDC",
  [CurrencyCode.BTC]: "BTC",
  [CurrencyCode.ETH]: "ETH",
  [CurrencyCode.LTC]: "LTC",
  [CurrencyCode.TRX]: "TRX",
  [CurrencyCode.BNB]: "BNB",
  [CurrencyCode.SOL]: "SOL",
  [CurrencyCode.TON]: "GRAM",
  [CurrencyCode.POLYGON]: "POLYGON",
  [CurrencyCode.ARS]: "ARS",
  [CurrencyCode.UZS]: "UZS",
  [CurrencyCode.CLP]: "CLP",
  [CurrencyCode.COP]: "COP",
  [CurrencyCode.VES]: "VES",
};

export const NETWORK_CODE_LABEL: Record<number, string> = {
  [NetworkCode.ETH]: "ETH",
  [NetworkCode.ERC20]: "ERC-20",
  [NetworkCode.BEP20]: "BEP-20",
  [NetworkCode.TRC20]: "TRC-20",
  [NetworkCode.POLYGON]: "Polygon",
  [NetworkCode.CARD]: "Card",
  [NetworkCode.SBP]: "SBP",
  [NetworkCode.PIX]: "PIX",
  [NetworkCode.STRIPE]: "Stripe",
  [NetworkCode.TON]: "GRAM",
  [NetworkCode.SOL]: "SOL",
  [NetworkCode.BTC]: "BTC",
  [NetworkCode.PAYPAL]: "PayPal",
  [NetworkCode.BINANCEPAY]: "BinancePay",
  [NetworkCode.KUCOINPAY]: "KuCoinPay",
};

export const PAYMENT_PROVIDER_LABEL: Record<number, string> = {
  [PaymentProvider.LEGACY]: "Legacy",
  [PaymentProvider.CRONIKA]: "Cronika",
  [PaymentProvider.NOWPAYMENTS]: "NowPayments",
  [PaymentProvider.LAVATOP]: "Lavatop",
  [PaymentProvider.P2P]: "P2P",
  [PaymentProvider.PAYPORT]: "PayPort",
  [PaymentProvider.BITNBOX]: "BitNBox",
};
